import apiClient from './apiClient'

export const uploadFile = async (file) => {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('destination', 'blog')

  try {
    const response = await apiClient.post('/uploads/', formData, {
      timeout: 60000,
    })
    return response.data
  } catch (error) {
    throw new Error(error.response?.data?.message || 'Error al subir el archivo')
  }
}

// Función para obtener las imágenes del carousel públicas
export const getPublicCarouselImages = async () => {
  try {
    const response = await apiClient.get('/uploads/carousel/public_carousel/')
    return response.data
  } catch (error) {
    console.error('Error fetching carousel images:', error)
    throw new Error(error.response?.data?.message || 'Error al obtener las imágenes del carousel')
  }
}

// Función para obtener las imágenes del carousel (admin)
export const getCarouselImages = async () => {
  try {
    const response = await apiClient.get('/uploads/carousel/')
    return response.data
  } catch (error) {
    console.error('Error fetching carousel images:', error)
    throw new Error(error.response?.data?.message || 'Error al obtener las imágenes del carousel')
  }
}

// Función para actualizar el estado activo de una imagen
export const updateCarouselImageStatus = async (id, isActive) => {
  try {
    const response = await apiClient.patch(
      `/uploads/carousel/${id}/`,
      { is_active: isActive },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`
        }
      }
    )
    return response.data
  } catch (error) {
    console.error('Error updating carousel image status:', error)
    throw new Error(error.response?.data?.message || 'Error al actualizar el estado de la imagen')
  }
}

// Función para cambiar el orden de las imágenes del carousel
export const updateCarouselImageOrder = async (imageId1, newOrder1, imageId2, newOrder2) => {
  try {
    // Realizamos las dos actualizaciones en paralelo
    const [response1, response2] = await Promise.all([
      apiClient.patch(
        `/uploads/carousel/${imageId1}/`, 
        { order: newOrder1 },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`
          }
        }
      ),
      apiClient.patch(
        `/uploads/carousel/${imageId2}/`, 
        { order: newOrder2 },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`
          }
        }
      )
    ])
    
    return { image1: response1.data, image2: response2.data }
  } catch (error) {
    console.error('Error updating carousel image order:', error)
    throw new Error(error.response?.data?.message || 'Error al actualizar el orden de las imágenes')
  }
}

// Función para subir una nueva imagen al carousel
export const uploadCarouselImage = async (imageData) => {
  const formData = new FormData()
  
  // Agregamos los datos básicos
  formData.append('title', imageData.title)
  if (imageData.description) formData.append('description', imageData.description)
  formData.append('link', imageData.link || '/productos')
  if (imageData.buttonText) formData.append('button_text', imageData.buttonText)
  formData.append('order', imageData.order || 0)
  formData.append('is_active', imageData.isActive !== undefined ? imageData.isActive : true)
  
  // Agregamos la imagen
  if (imageData.desktopImage) {
    formData.append('desktop_image', imageData.desktopImage)
  }
  if (imageData.mobileImage) {
    formData.append('mobile_image', imageData.mobileImage)
  }
  
  try {
    const response = await apiClient.post('/uploads/carousel/', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`
      }
    })
    return response.data
  } catch (error) {
    console.error('Error uploading carousel image:', error)
    throw new Error(error.response?.data?.message || 'Error al subir la imagen del carousel')
  }
}

// Función para actualizar una imagen existente en el carousel
export const updateCarouselImage = async (id, imageData) => {
  try {
    const formData = new FormData()
    
    // Agregamos los datos básicos que se van a actualizar
    if (imageData.title) formData.append('title', imageData.title)
    if (imageData.description) formData.append('description', imageData.description)
    if (imageData.link) formData.append('link', imageData.link)
    if (imageData.buttonText) formData.append('button_text', imageData.buttonText)
    if (imageData.order !== undefined) formData.append('order', imageData.order)
    if (imageData.isActive !== undefined) formData.append('is_active', imageData.isActive)
    
    // Agregamos la imagen nueva si existe
    if (imageData.desktopImage) {
      formData.append('desktop_image', imageData.desktopImage)
    }
    if (imageData.mobileImage) {
      formData.append('mobile_image', imageData.mobileImage)
    }
    
    const response = await apiClient.patch(
      `/uploads/carousel/${id}/`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`
        }
      }
    );
    
    return response.data;
  } catch (error) {
    console.error('Error updating carousel image:', error);
    throw new Error(error.response?.data?.detail || 'Error al actualizar la imagen');
  }
}

// Nueva función para eliminar completamente una imagen del carousel
export const deleteCarouselImage = async (id) => {
  try {
    const response = await apiClient.delete(
      `/uploads/carousel/${id}/`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`
        }
      }
    );
    return response.data;
  } catch (error) {
    console.error('Error deleting carousel image:', error);
    throw new Error(error.response?.data?.detail || 'Error al eliminar la imagen');
  }
}

